import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppConfigService } from '../providers/config.service';

export interface TenantStats {
  total_assets_original_size_including_subgalleries: number;
  total_assets_version_size_including_subgalleries: number;
  total_assets_original_number_including_subgalleries: number;
}
export interface GalleryStats {
  total_assets_original_size_including_subgalleries: number;
  total_assets_version_size_including_subgalleries: number;
}

@Injectable({
  providedIn: 'root',
})
export class StatsService {
  private readonly tenantStatsSubject = new BehaviorSubject<TenantStats>(undefined);
  private galleryStatsSubjects: Map<string, BehaviorSubject<GalleryStats>> = new Map();

  constructor(private config: AppConfigService, private http: HttpClient) {}

  public getTenantStats() {
    this.loadTenantStats();
    return this.tenantStatsSubject;
  }

  private loadTenantStats() {
    this.http.get<any>(`${this.config.apiEndpoint}/overview`).subscribe(resp => {
      this.tenantStatsSubject.next(resp);
    });
  }

  public getGalleryStats(galleryId: string) {
    if (!this.galleryStatsSubjects.has(galleryId)) {
      this.galleryStatsSubjects.set(galleryId, new BehaviorSubject(undefined));
    }
    this.loadGalleryStats(galleryId);
    return this.galleryStatsSubjects.get(galleryId);
  }

  public getGalleryStats2(galleryId: string) {
    return this.http.get<GalleryStats>(`${this.config.apiEndpoint}/galleries/${galleryId}/overview?ignore_errors`);
  }

  private loadGalleryStats(galleryId: string) {
    this.http.get<any>(`${this.config.apiEndpoint}/galleries/${galleryId}/overview?ignore_errors`).subscribe(resp => {
      this.galleryStatsSubjects.get(galleryId).next(resp);
    });
  }

  public reloadAllGalleryStats() {
    Array.from(this.galleryStatsSubjects.keys()).forEach(galleryId => this.loadGalleryStats(galleryId));
  }
}
